// RMSDateTimePicker.jsx

import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import useIsFieldRequired from '../../../utility/useIsFieldRequired';
import { RMSButton } from '../../buttons/index';
import DATE_FORMATS from '../../../constants/dateFormats';
import { getFormat24 } from 'reducers/TimeReducer';

const RMSDateTimePicker = ({
  name,
  label,
  disabled = false,
  minDate,
  maxDate,
  size = 'small',
  showNowButton = false,
  ...rest
}) => {
  const { control, trigger, setValue } = useFormContext();
  const isRequired = useIsFieldRequired(name);
  const format24 = getFormat24();

  const format = !format24 ? DATE_FORMATS.MM_DD_YYYY_HH_mm_A : DATE_FORMATS.MM_DD_YYYY_HH_mm;
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Controller
        name={name}
        control={control}
        defaultValue={null}
        render={({ field, fieldState: { error } }) => (
          <Box className="rms-date-time-wrapper">
            {showNowButton && (
              <RMSButton
                disabled={disabled}
                label="Now"
                size="small"
                className="rms-now-chip"
                onClick={() => {
                  const now = new Date();

                  setValue(name, now, {
                    shouldDirty: true,
                    shouldValidate: true,
                  });

                  trigger(name);
                }}
              />
            )}

            <KeyboardDateTimePicker
              {...rest}
              autoOk
              fullWidth
              ampm={!format24}
              variant="inline"
              inputVariant="outlined"
              size={size}
              format={format}
              label={label}
              disabled={disabled}
              value={field.value || null}
              minDate={minDate}
              maxDate={maxDate}
              onChange={(date) => {
                field.onChange(date);
                trigger(name);
              }}
              onBlur={field.onBlur}
              error={!!error}
              helperText={error?.message}
              required={isRequired}
            />
          </Box>
        )}
      />
    </MuiPickersUtilsProvider>
  );
};

export default RMSDateTimePicker;
